import React, {useContext} from "react";
import {Box, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {HugeiconsIcon} from "@hugeicons/react";
import {ArrowRight01Icon, InformationCircleIcon} from "@hugeicons/core-free-icons";
import {SignInContext} from "../../../context/SignInContext";

export const ServiceNotConfiguredBanner = ({label}) => {
  const {currentUser} = useContext(SignInContext);
  const isAdmin = currentUser?.roles?.includes("admin");

  return (
    <Box sx={{
      display: "flex", alignItems: "center", gap: 1.5, p: 2, borderRadius: "14px",
      bgcolor: "rgba(132, 145, 247, 0.08)",
    }}>
      <HugeiconsIcon icon={InformationCircleIcon} size={18} style={{color: "#8491F7", flexShrink: 0}}/>
      <Typography sx={{fontSize: 13, color: "#23264D", flex: 1}}>
        No {label} URL is set on this project's backend configuration.
        {!isAdmin && " Ask an admin to set it."}
      </Typography>
      {isAdmin && (
        <Box
          component={Link}
          to={"/backend-configuration"}
          sx={{
            display: "flex", alignItems: "center", gap: 0.5, whiteSpace: "nowrap",
            fontSize: 13, fontWeight: 600, color: "#4B55C9", textDecoration: "none",
            "&:hover": {textDecoration: "underline"},
          }}
        >
          Go to Backend Configurations
          <HugeiconsIcon icon={ArrowRight01Icon} size={14}/>
        </Box>
      )}
    </Box>
  );
};
